export default {
  title: 'Partner hinzufügen',
  mode: {
    single: 'Einzelner Partner',
    bulk: 'Mehrere (CSV)',
  },
  buttons: {
    send_invite: 'Einladung senden',
  },
  bulk: {
    form: {
      file: {
        label: 'Partnerliste (CSV)',
        hint: 'Ein Partner pro Zeile. Pflichtspalten: Email, Company country sowie Registered company name oder Company name. Brand name ist optional und wird zum Anzeigenamen für Kunden. Alle Zeilen werden geprüft, bevor etwas angelegt wird.',
      },
    },
    buttons: {
      select_file: 'CSV-Datei auswählen',
      download_template: 'Importvorlage herunterladen',
      import: 'Partner importieren',
    },
    columns: {
      legal_name: 'Registered company name / Company name',
      display_name: 'Brand name',
      admin_email: 'Email',
      company_country: 'Company country',
    },
    errors: {
      title: 'Die Datei konnte nicht importiert werden.',
      nothing_imported:
        'Es wurde kein Partner angelegt. Korrigieren Sie die oben genannten Zeilen und laden Sie die Datei erneut hoch.',
      columns: {
        row: 'Zeile',
        column: 'Spalte',
        error: 'Fehler',
      },
    },
    toasts: {
      queued_one:
        '{{count}} Partner in der Warteschlange — die Einladung wird gesendet, sobald er angelegt ist. Sie erhalten eine Zusammenfassung per E-Mail, wenn der Import abgeschlossen ist.',
      queued_other:
        '{{count}} Partner in der Warteschlange — die Einladungen werden gesendet, sobald sie angelegt sind. Sie erhalten eine Zusammenfassung per E-Mail, wenn der Import abgeschlossen ist.',
    },
    footnote:
      'Die Partner werden nacheinander im Hintergrund mit derselben Einrichtung wie ein einzelner Partner angelegt: Einladungs-E-Mail, Dashboard-Subdomain und Standard-Shop-Domain. Das Land bestimmt Währung und Zeitzone; ein Bundesstaat kann später im Partnerprofil gesetzt werden. Die Zahlungsabwicklung wird anschließend im Tab „Zahlungen“ des jeweiligen Partners konfiguriert.',
  },
  form: {
    name: {
      label: 'Partnername',
    },
    admin_email: {
      label: 'E-Mail des Admins (Einladungsempfänger)',
      hint: 'Wir senden eine Einladung zur Einrichtung des Kontos per E-Mail.',
    },
    display_name: {
      label: 'Anzeigename für Kunden',
      hint: 'Das „Powered by ___“-Label, das Kunden sehen. Entspricht standardmäßig dem Partnernamen.',
    },
    region: {
      label: 'Land',
      placeholder: 'Land auswählen',
      hint: 'Legt Währung, Zeitzone und Einladungssprache des Partners fest.',
      summary: 'Währung {{currency}} · {{timezone}} · Einladungssprache {{language}}',
      default_root: 'Shop-Domain: Neue Marken laufen unter {{host}}',
    },
    sub_region: {
      label: 'Bundesstaat',
      placeholder: 'Gesamtes Land',
      hint: 'Optional — leer lassen, um das gesamte Land zu verwenden.',
    },
    language: {
      label: 'Einladungssprache',
      placeholder: '{{language}} (Standard)',
      hint: 'Optional — standardmäßig die Hauptsprache des Landes.',
    },
  },
  footnote: 'Branding und Beteiligung können konfiguriert werden, nachdem der Partner die Einladung angenommen hat.',
  toasts: {
    created: 'Partner erstellt — die Einladungs-E-Mail ist unterwegs.',
  },
};
